import styled from 'styled-components';
import { VISUALIZATION_CONTENT_CONTAINER_CLASS_NAME } from '@ardoq/global-consts';
import { classes } from '@ardoq/common-helpers';

export const ComponentMatrixMainContainer = styled.div.attrs(props => ({
  className: classes(
    VISUALIZATION_CONTENT_CONTAINER_CLASS_NAME,
    props.className
  ),
}))`
  height: 100%;
  width: 100%;
  border: none;
  padding: 5px;
  display: grid;
  overflow: hidden;
  grid-template-rows: auto 1fr;
  grid-template-columns: auto 1fr;
  .forExport & {
    padding: 0px;
  }
`;
